import React, { Component } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  addPendingCallAction,
  removePendingCallAction,
} from "features/application/loader/redux/actions";

import LoaderView from "features/application/loader/component/view";

const mapStateToProps = (state) => ({
  pendingCallsNumber: state.loaderReducer.pendingCallsNumber,
});

const mapDispatchToProps = (dispatch) => ({
  addPendingCall: () => dispatch(addPendingCallAction()),
  removePendingCall: () => dispatch(removePendingCallAction()),
});

class Loader extends Component {
  componentDidMount() {
    const { addPendingCall, removePendingCall } = this.props;

    axios.interceptors.request.use(
      (config) => {
        addPendingCall();

        return config;
      },
      (error) => {
        addPendingCall();

        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        setTimeout(() => removePendingCall(), 200);

        return response;
      },
      (error) => {
        setTimeout(() => removePendingCall(), 200);

        return Promise.reject(error);
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { pendingCallsNumber } = this.props;

    if (document) {
      const form = document.querySelector(".application__form");
      const overlay = document.querySelector(".loader__overlay");
      const htmlElement = document.querySelector("html");
      const bodyElement = document.querySelector("body");

      if (nextProps.pendingCallsNumber !== pendingCallsNumber) {
        if (nextProps.pendingCallsNumber) {
          htmlElement.style.overflowY = "hidden";
          overlay.classList.remove("loader__overlay--out");
          overlay.classList.add("loader__overlay--in");

          if (form) {
            form.style.opacity = "0";
            bodyElement.style.background = "#000";
          }
        } else {
          overlay.classList.remove("loader__overlay--in");
          overlay.classList.add("loader__overlay--out");

          if (form) {
            form.style.opacity = "1";
            bodyElement.style.background = "#fff";
          }

          setTimeout(() => {
            htmlElement.style.overflowY = "visible";
          }, 400);
        }
      }
    }
  }

  render() {
    const { pendingCallsNumber } = this.props;

    return <LoaderView pendingCallsNumber={pendingCallsNumber} />;
  }
}

Loader.propTypes = {
  addPendingCall: PropTypes.func,
  removePendingCall: PropTypes.func,
  pendingCallsNumber: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
